import React, { forwardRef } from 'react';

import { makeStyles } from '@mui/styles';
import { CustomContentProps, SnackbarContent } from 'notistack';

import Card from '@mui/material/Card';

import NotificationsIcon from '@mui/icons-material/Notifications';

const useStyles = makeStyles(() => ({
  root: {
    '@media (min-width:600px)': {
      minWidth: '344px !important',
    },
  },
  card: {
    width: '100%',
  },
  typography: {
    color: '#000',
  },
  actionRoot: {
    padding: '8px 8px 8px 16px',
    justifyContent: 'space-between',
  },
  icons: {
    marginLeft: 'auto',
  },
  expand: {
    padding: '8px 8px',
    transform: 'rotate(0deg)',
    color: '#000',
    transition: 'all .2s',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  paper: {
    backgroundColor: '#fff',
    padding: 16,
  },
  checkIcon: {
    fontSize: 20,
    paddingRight: 4,
  },
  button: {
    padding: 0,
    textTransform: 'none',
  },
}));

interface NotificationSnackProps extends CustomContentProps {
  allowDownload?: boolean;
}

const NotificationSnack = forwardRef<HTMLDivElement, NotificationSnackProps>(
  ({ id, ...props }, ref) => {
    const classes = useStyles();

    return (
      <SnackbarContent ref={ref}>
        <Card className={'notification-snack'}>
          <div className="d-flex justify-content-start align-items-center mb-2">
            <NotificationsIcon className="" />
            <h5 className="m-0 p-0">Notification</h5>
          </div>
          <p className="m-0 p-0 ps-4">{props.message}</p>
        </Card>
      </SnackbarContent>
    );
  },
);

NotificationSnack.displayName = 'ReportComplete';

export default NotificationSnack;
